import React, { useState, useEffect } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ilceler, iller } from '../assets/common';
import Dropdown from './Dropdown';

const StateSelector = ({
    formik,
    namePrefix,
    labelIl,
    labelIlce,
    required = false,
    ilFieldName,
    ilceFieldName
}) => {
    const [ilList, setIlList] = useState([]);
    const [ilceList, setIlceList] = useState([]);
    const [loading, setLoading] = useState(false);

    const actualIlFieldName = ilFieldName || `${namePrefix}Il`;
    const actualIlceFieldName = ilceFieldName || `${namePrefix}Ilce`;

    useEffect(() => {
        setIlList(iller);
    }, []);

    useEffect(() => {
        if (formik.values[actualIlFieldName]) {
            setLoading(true);
            const filteredIlceler = ilceler.filter(ilce => ilce.il === formik.values[actualIlFieldName].il);
            setIlceList(filteredIlceler);
            setLoading(false);
        } else {
            setIlceList([]);
            formik.setFieldValue(actualIlceFieldName, null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values[actualIlFieldName]]);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4 ">
            {loading && <ProgressSpinner animation="border" />}
            <Dropdown
                id={actualIlFieldName}
                filter
                name={actualIlFieldName}
                value={formik.values[actualIlFieldName]}
                onChange={(e) => {
                    formik.setFieldValue(actualIlFieldName, e.value);
                    formik.setFieldValue(actualIlceFieldName, null);
                }}
                onBlur={() => formik.setFieldTouched(actualIlFieldName, true)}
                options={ilList}
                optionLabel="il"
                showClear={true}
                label={labelIl}
                error={formik.errors[actualIlFieldName]}
                touched={formik.touched[actualIlFieldName]}
                required={required}
            />
            <Dropdown
                id={actualIlceFieldName}
                filter
                name={actualIlceFieldName}
                value={formik.values[actualIlceFieldName]}
                onChange={(e) => formik.setFieldValue(actualIlceFieldName, e.value)}
                onBlur={() => formik.setFieldTouched(actualIlceFieldName, true)}
                options={ilceList}
                optionLabel="ilce"
                disabled={!formik.values[actualIlFieldName]}
                showClear={true}
                label={labelIlce}
                error={formik.errors[actualIlceFieldName]}
                touched={formik.touched[actualIlceFieldName]}
                required={required}
            />
        </div>
    );
};

export default StateSelector;